import { all, takeEvery, put, call } from 'redux-saga/effects';
import { IRequestParams, ICollectionResponse } from '@dash/apiInstance';
import { tableConfig } from 'src/settings';
import { isAUS } from 'src/helpers/countriesHelpers';
import ApiInstance from 'src/helpers/apiInstance';
import { sendRequest } from '../../../../../../../helpers/saga';
import { logger } from '../../../../../../../helpers/logger';
import actions from './actions';
import actionTypes from './actionTypes';
import { IBankAccount, ILoadBankAccountsPathParams } from './types';
import notifications from '../../../../../../../redux/notifications/actions';
import { LoadBankAccountsRequestAction } from './actions.d';

const unitApi = new ApiInstance('units/:id/bank_accounts');
const unitAusApi = new ApiInstance('units/:id/payment_methods/becs_bank_accounts');

const subunitApi = new ApiInstance('subunits/:id/bank_accounts');
const subunitAusApi = new ApiInstance('subunits/:id/payment_methods/becs_bank_accounts');

function* loadBankAccounts({ payload }: LoadBankAccountsRequestAction<ILoadBankAccountsPathParams, {}>) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id, type } = payload;
    let result: ICollectionResponse<IBankAccount>;

    if (isAUS()) {
      const api = type === 'subUnit' ? subunitAusApi : unitAusApi;

      result = yield call<any, IRequestParams<ILoadBankAccountsPathParams, {}>, string>(
        sendRequest,
        api.get,
        { search: { page, pageSize, column, order, filter }, pathParams: { id } },
        notifications.REQUEST_ERROR,
      );

      if (result) {
        yield put(
          actions.loadBankAccountsSuccess({
            bankAccounts: result?.data?.records,
            total: result.data?.total,
            filteredTotal: result.data?.filteredCount,
            sortableColumns: result.data?.sortableColumns,
          }),
        );
      } else {
        yield put(actions.loadBankAccountsError());
      }
    } else {
      const api = type === 'subUnit' ? subunitApi : unitApi;

      result = yield call<any, IRequestParams<ILoadBankAccountsPathParams, {}>, string>(
        sendRequest,
        api.get,
        { search: { page, pageSize, column, order, filter }, pathParams: { id } },
        notifications.REQUEST_ERROR,
      );

      if (result) {
        yield put(
          actions.loadBankAccountsSuccess({
            bankAccounts: result?.data?.records,
            total: result.data?.total,
            filteredTotal: result.data?.filteredCount,
            sortableColumns: result.data?.sortableColumns,
          }),
        );
      } else {
        yield put(actions.loadBankAccountsError());
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.LOAD_BANK_ACCOUNTS_REQUEST, loadBankAccounts)]);
}
